export const GET_TAKEAWAY_DETAILS_SUCCESS = 'GET_TAKEAWAY_DETAILS_SUCCESS';
export const SET_CUSTOM_TAKEAWAYS = 'SET_CUSTOM_TAKEAWAYS';
export const SET_DESIGN_TAKEWAYS = 'SET_DESIGN_TAKEWAYS';